"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeName = void 0;
var AttributeName;
(function (AttributeName) {
    AttributeName["SLSUUID"] = "SLSUUID";
    AttributeName["STORE_NAME"] = "STORE_NAME";
    AttributeName["CHANNEL_ORDER_ID"] = "CHANNEL_ORDER_ID";
    AttributeName["SHIPPING_CLASS"] = "SHIPPING_CLASS";
    AttributeName["MARKETPLACE_SHIPPING_METHOD"] = "MARKETPLACE_SHIPPING_METHOD";
    AttributeName["REQUIRED_DAYS_TO_DELIVERY"] = "REQUIRED_DAYS_TO_DELIVERY";
    AttributeName["DELIVERY_REQUIRED_TIME"] = "DELIVERY_REQUIRED_TIME";
    AttributeName["SHIP_BY_TIME"] = "SHIP_BY_TIME";
    AttributeName["IS_SUBSCRIPTION_ORDER"] = "IS_SUBSCRIPTION_ORDER";
    AttributeName["SELLER_ENTITY_NAME"] = "SELLER_ENTITY_NAME";
})(AttributeName || (exports.AttributeName = AttributeName = {}));
//# sourceMappingURL=OrderAttributeDto.js.map